'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    StoreUtils = require('../utils/StoreUtils'),
    createStore = StoreUtils.createStore;

var _context = null;

function setContext(context) {
  _context = context;
}

var NavigationStore = createStore({
  getContext() {
    return _context;
  },

  isActive(id) {
    return _context && _context.id === id;
  }
});

AppDispatcher.register(function (payload) {
  var action = payload.action;

  switch (action.type) {
  case ActionTypes.SET_NAVIGATION_CONTEXT:
    setContext(action.context);
    NavigationStore.emitChange();
    break;
  case ActionTypes.CLEAR_NAVIGATION_CONTEXT:
    setContext(null);
    NavigationStore.emitChange();
    break;
  }
});

module.exports = NavigationStore;


/** WEBPACK FOOTER **
 ** ./stores/NavigationStore.js
 **/